import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class UserInputService {
  private formData: { [key: string]: any } = {}

  setValue (key: string, value: any): void {
    if (key === 'first_name' || key === 'last_name' ||
        key === 'primary_mobile_number' || key === 'primary_email' ||
        key === 'dialCode' || key === 'marketing_acceptance_flag' ||
      key === 'date_of_birth' || key === 'preferredServiceGTM') {
      this.formData[key] = { option_value: value, option_label: value }
    } else {
      this.formData[key] = value
    }
  }

  getValue (key: string): any {
    return this.formData[key]
  }

  getAllValues (): { [key: string]: any } {
    return { ...this.formData }
  }

  deleteValue (field: string): void {
    delete this.formData[field]
  }

  clearAll (): void {
    this.formData = {}
  }
}
